<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-3">
                    <label><label style="color: red; height: 2px;" >*</label>
                        از تاریخ</label>
                    <Datepicker simple auto-submit id="from-date" locale="fa" input-format="YYYY-MM-DD" :max="today" v-model="fromDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
                <div class="col-md-3">
                    <label><label style="color: red; height: 2px;" >*</label>
                        تا تاریخ</label>
                    <Datepicker simple auto-submit id="to-date" locale="fa" input-format="YYYY-MM-DD" :max="today" v-model="toDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
                <div class="col-md-3">
                    <label>شماره ارجاع / شماره درخواست</label>
                    <input class="form-control ltr-input" v-model="refrenceno" v-mask="'###################'">
                </div>
                <div class="col-md-3">
                    <label>شماره کارت</label>
                    <input class="form-control ltr-input" v-model="pan" v-mask="'####-####-####-####'">
                </div>
            </div>
            <div class="row" style="display: flex; justify-content: end;">
                <div class="col-md-3" style="margin-top: 29px;">
                    <button class="btn btn-primary btn-block" @click="submit" :disabled="!fromDate || !toDate">
                        <i class="si si-magnifier"></i>
                        جستجو
                    </button>
                </div>
                <div class="col-md-3" style="margin-top: 29px;" v-if="rows.length">
                    <button class="btn btn-secondary" @click="downloadExcelFile" >دریافت خروجی Excel</button>
                </div>
            </div>
            <div class="row mt-3" v-if="showCard && rows.length">
                <div class="col-md-12" style="font-size:15px;color:green">
                    <p>مجموع واریز: {{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(lastIncreasesum) }} ریال</p>
                </div>
                <div class="col-md-12" style="font-size:15px;color:red">
                    <p>مجموع برداشت: {{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(lastDecreasesum) }} ریال</p>
                </div>
                <div class="col-md-12">
                    <p class="mb-0">مانده موجودی: {{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(lastDeposit) }} ریال</p>
                </div>
            </div>
            <div class="alert alert-info mt-4 mb-0" v-if="!rows.length && isSearched">
                <p class="mb-0">اطلاعاتی یافت نشد</p>
            </div>
            <hr v-if="rows.length">
            <table class="table table-hover table-bordered mb-0" v-if="rows.length">
                <thead>
                    <tr>
                        <th>نام و نام خانوادگی</th>
                        <th>کد ملی</th>
                        <th>شماره کارت</th>
                        <th>نوع کارت</th>
                        <th>مبلغ</th>
                        <th>شماره ارجاع</th>
                        <th>نوع پایانه</th>
                        <th>نوع تراکنش</th>
                        <th>وضعیت</th>
                        <th>موجودی</th>
                        <th>شناسه ترمینال</th>
                        <th>تاریخ</th>
                        <th>زمان</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row,index) in rows" :key="index">
                        <td>{{ (row.name ? row.name : 'بدون نام') + ' ' + (row.family ? row.family : 'بدون نام خانوادگی') }}</td>
                        <td>{{ row.nationalcodenumber }}</td>
                        <td>{{ row.pan }}</td>
                        <td>{{ row.cardtype }}</td>
                        <td>{{ row.amount ? new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(row.amount) : '0'}} ریال</td>
                        <td>{{ row.referenceno }}</td>
                        <td>{{ row.terminal_type }}</td>
                        <td>{{ row.txn_type }}</td>
                        <td v-if="row.status.includes('ناموفق')" class="text-danger">ناموفق</td>
                        <td v-else class="text-success">موفق</td>
                        <td>{{ row.ballance ? new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(row.ballance) : '0'}} ریال</td>
                        <td>{{ row.terminal_id }}</td>
                        <td>{{ row.datetran.replace(/\//g,'').slice(0,4) + '/' + row.datetran.replace(/\//g,'').slice(4,6) + '/' + row.datetran.replace(/\//g,'').slice(6,8) }}</td>
                        <td>{{ row.timetran }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="row mt-3" v-if="pages.length > 1" style="overflow-x: hidden;">
                <div class="col-12" style="overflow-x: auto;">
                    <ul class="pagination pagination-circled">
                        <li class="page-item" v-if="currentPage > 1">
                            <a class="page-link" href="#" v-on:click="currentPage--"><i class="icon ion-ios-arrow-forward"></i></a>
                        </li>
                        <li :class="currentPage == page ? 'page-item active' : 'page-item'" v-for="page in pages" :key="page">
                            <a class="page-link" href="#" v-on:click="currentPage = page">{{ page }}</a>
                        </li>
                        <li class="page-item" v-if="pages.length != currentPage">
                            <a class="page-link" href="#" v-on:click="currentPage++"><i class="icon ion-ios-arrow-back"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
            <p v-if="rows.length" class="mt-4 mb-0">تعداد کل تراکنش ها : {{ count }}</p>
            <p v-if="rows.length && showCard" class="mt-3 mb-0">مجموع مبلغ تراکنش ها : {{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(totalTransactions) }} ریال</p>
        </div>
    </div>
</template>

<script>
import moment from 'moment-jalaali';
export default {
    name: 'CustomerReport',
    data(){
        return {
            showLoading: false,
            isSearched: false,
            rows: [],
            fromDate: '',
            toDate: '',
            currentPage: 1,
            pan: '',
            refrenceno: '',
            pages: [1],
            perPage: 50,
            today: moment().format('jYYYY-jMM-jDD'),
            lastDeposit: 0,
            showCard: false,
            lastIncreasesum: 0,
            lastDecreasesum: 0,
            totalTransactions: 0,
            count: 0
        }
    },
    watch: {
        currentPage(value){
            this.currentPage = value;
            this.getData();
        }
    },
    methods: {
        getData(excel = false){
            this.showLoading = true;
            const postedData = {
                p_fromdate: this.fromDate.replace(/\//g,''),
                p_todate: this.toDate.replace(/\//g,''),
                p_offset: this.currentPage,
                p_limit: this.perPage,
                p_refrenceno: this.refrenceno,
                p_card: this.pan.replace(/-/g,''),
                excel
            };
            this.$api.post('Branches/Report/Transaction',postedData).then(({data}) => {
                if(data.status && excel)
                    window.open('https://cardapi.sabinarya.com/download/' + data.result.fileName)
                if(data.status && data.result && data.result.v_result){
                    this.rows = data.result.v_result;
                    this.count = data.result.v_count[0].cnt_total;
                    if(data.result.v_result.length){
                        this.lastIncreasesum = data.result.v_result[0].increasesum;
                        this.lastDecreasesum = data.result.v_result[0].decreasesum;
                        this.totalTransactions = data.result.v_count[0].amt_total;
                        this.lastDeposit = data.result.v_result[0].remind;
                    }
                    let calcPages = Math.ceil((this.count) / this.perPage);
                    calcPages = calcPages > 1 ? calcPages : 1
                    let pagesArray = [];
                    for(let i = 1;i <= calcPages;i++)
                        pagesArray.push(i);
                    this.pages = pagesArray;
                }else{
                    this.rows = [];
                }
            }).finally(() => {
                this.isSearched = true;
                this.showLoading = false;
                if(this.pan){
                    this.showCard = true;
                }
            });
        },
        downloadExcelFile(){
            this.getData(true);
        },
        submit(){
            this.getData();
        }
    }
}
</script>